import React from "react"

import globalStyles from "../../../../App.module.scss"

export default function TestOperators() {
    return (
        <div className={globalStyles.article}>
            <h1>Test operators — [ ] vs [[ ]] vs (( ))</h1>
            <p>Three different constructs all get called "if statements", but they parse very differently.
                Complements the operator tables on the <b>Loops</b> page.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '600px'}}>
                    <thead>
                    <tr>
                        <th>Construct</th>
                        <th>What it is</th>
                        <th>Notes</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>[ expr ]</code></td>
                        <td>Alias for the <code>test</code> command (a real program)</td>
                        <td>Word-splits and glob-expands unquoted variables — always quote them</td>
                    </tr>
                    <tr>
                        <td><code>[[ expr ]]</code></td>
                        <td>Bash keyword, not a command</td>
                        <td>No word-splitting/glob issues, supports <code>&&</code>/<code>||</code> and
                            <code> ==</code> pattern matching directly inside it</td>
                    </tr>
                    <tr>
                        <td><code>(( expr ))</code></td>
                        <td>Arithmetic evaluation</td>
                        <td>For numeric comparisons — <code>&gt;</code>/<code>&lt;</code> mean numeric
                            comparison here, unlike inside <code>[ ]</code></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Why quoting matters in [ ]</h3>
            <pre className={globalStyles.code}>
                <code>
                    name=""<br/>
                    <span style={{opacity: 0.7}}># Broken: expands to `[ = foo ]`, a syntax error</span><br/>
                    [ $name = "foo" ]<br/>
                    <br/>
                    <span style={{opacity: 0.7}}># Safe: quoted, always a well-formed comparison</span><br/>
                    [ "$name" = "foo" ]
                </code>
            </pre>

            <h3>[[ ]] avoids that class of bug</h3>
            <pre className={globalStyles.code}>
                <code>
                    name=""<br/>
                    [[ $name == "foo" ]] &amp;&amp; echo match<br/>
                    <span style={{opacity: 0.7}}># No quoting required, no word-splitting on the empty value</span>
                </code>
            </pre>

            <h3>Numeric comparison: [ ] vs (( ))</h3>
            <pre className={globalStyles.code}>
                <code>
                    a=5; b=10<br/>
                    [ "$a" -lt "$b" ] &amp;&amp; echo "a is less"<br/>
                    (( a &lt; b )) &amp;&amp; echo "a is less"
                </code>
            </pre>

            <h3>Rule of thumb</h3>
            <p>Use <code>[[ ]]</code> for string/file tests, <code>(( ))</code> for arithmetic, and reach for
                plain <code>[ ]</code> only when writing a <code>#!/bin/sh</code> script that must stay
                POSIX-portable (<code>[[ ]]</code> and <code>(( ))</code> are bash/ksh/zsh extensions).</p>
        </div>
    )
}
